<template>
<div id="booksTop">

        <!-- BUTTONS TO TOGGLE BETWEEN ALL BOOKS AND MY BOOKS --->
        <div class="bookSelector toggleButtons ">
        <v-row justify="center" >
          <v-btn-toggle
          v-model="toggle_exclusive"
        >
    <v-dialog
      v-model="dialognewbook"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          fab
        >
        <v-icon class="m4u_text--text">mdi-book-plus</v-icon>

        </v-btn>
      </template>
      <v-card  :width="{'70vw': $vuetify.breakpoint.smAndDown, '30vw': $vuetify.breakpoint.mdAndUp}">
        <v-card-title>
          <h3 class="m4u_text--text">New Book</h3>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="8"
              >
                <v-text-field
                  label="Book Title"
                  required
                  v-model="newBookTitle"
                  color="m4u_text"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="8"
              >
        <v-select
        v-model="CircleID"
        :items="circles"
        label="Share with..."
        item-text="CircleName"
        item-value="CircleID"
        return-object
        required
        color="m4u_text"
        ></v-select>
      </v-col>

    <v-switch
      v-model="switch1"
      :label="'Is this a time capsule?'"
      @click="setUpDate()"
      color="m4u_text"
    ></v-switch>


            </v-row>
<!---TC Date Fields --->
<h3 v-if="switch1 === true" class="m4u_text--text">When do you want to release this time capsule?</h3> <br/>
 <v-row>
          <v-text-field
        v-if="switch1 === true"
        label="Year"
        required
        v-model="tcYear"
        type="number"
        color="m4u_text"
      ></v-text-field>
      
      <v-text-field
      v-if="switch1 === true"
        label="Month"
        required
        v-model="tcMonth"
        type="number"
        color="m4u_text"
      ></v-text-field>
      
      <v-text-field
      v-if="switch1 === true"
        label="Day"
        required
        v-model="tcDay"
        type="number"
        color="m4u_text"
      ></v-text-field>
 </v-row>

<!---END OF TC Date Fields --->
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="dialognewbook = false"
          >
            Close
          </v-btn>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="saveNewBook()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
          <v-btn class= "primary m4u_text--text" @click="getBooks">
            All Books
          </v-btn>
          <v-btn class= "primary m4u_text--text" @click="getMyBookList" >
            My Books
          </v-btn>
        </v-btn-toggle>
            </v-row>
        </div>

    <div v-for="book in books" :key="book.BookID" >
      <BookCard :book="book"  @refresh="refresh" />
    </div>
          <v-btn v-scroll="onScroll" v-show="fab"
          fab fixed bottom right color="primary dark" @click="toTop()">
            <v-icon class="m4u_text--text">mdi-arrow-up-circle</v-icon>
         </v-btn>

</div>

</template>
<script>

import EventService from '@/services/EventService.js'; 
import BookCard from '../components/BookCard';


export default {

  data() {
    return {
        books: [],
        bookID: '',
        dialognewbook: '',
        newBookTitle: '',
        switch1: false,
        dialogTC: false, 
        modalTC: false, 
        dateTC: '',
        tcYear: '',
        tcMonth: '',
        tcDay: '',
        circles: [],
        CircleID: '',
        fab: false,
        toggle_exclusive: undefined,

       }
    },
  
  components: {
    BookCard
  },
  
mounted() {

    this.getBooks(this.user.UserID);
    this.startTCDate;
    this.getMyCircles(this.user.UserID);
  },


computed: {
  user(){
    return this.$store.state.user
  }
},

  loginState(){
    return this.$store.state.loginState
  },

  methods: {
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.fab =  top > 10
    },
    toTop () {
      this.$vuetify.goTo(0)
    },

    async getBooks() {
      await EventService.getBooks(this.user.UserID)
      .then(
        (books => {
          this.$set(this, "books", books);
        }).bind(this)

      );
    },

    async getMyBookList() {
      await EventService.getMyBookList(this.user.UserID)
      .then(
        (books => {
          this.$set(this, "books", books);
        }).bind(this)

      );
    },

    async refresh(newbooks) {
      this.$set(this, "books", newbooks)
    },

    async saveNewBook() {
      await EventService.newBook(this.user.UserID, this.newBookTitle, this.tcDate, this.CircleID.CircleID)
      .then(
        async () => {
          this.dialognewbook = false
          await this.getBooks(this.user.UserID)
          this.$nextTick()
        }
      );
    },


    async getMyCircles() {
      await EventService.getMyCircles(this.user.UserID)
      .then(
        (circles => {
          this.$set(this, "circles", circles);
        }).bind(this)

      );
    },


    async setUpDate() {
      if(this.switch1 === true) {
      var dateObj = new Date();
      this.tcMonth = dateObj.getUTCMonth() + 1; //months from 1-12
      if(this.tcMonth <10)  { this.tcMonth ='0'+ this.tcMonth } 
      this.tcDay = dateObj.getUTCDate();
       if(this.tcDay <10)  { this.tcDay ='0'+ this.tcDay } 
      this.tcYear = dateObj.getUTCFullYear();
      this.tcDate = this.tcYear + "-" + this.tcMonth + "-" + this.tcDay; 
      }
      if(this.switch1 == false) {
        this.tcMonth = ''
        this.tcDay = ''
        this.tcYear = ''
        this.tcDate = ''
      }
    }
  }

}


</script>
<style lang="scss" scoped>
  .bookButton {
    overflow: hidden;
    height: auto;
      width: auto;
  }
  .bookDiv {
  border: solid;
  border-width: 8px;
  border-color: #FFCB47;
  background-color: white;
  padding: 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  max-height: 80%;
  margin: 1em;
  border-radius: 5%;
  background-image: url('/public/bookbackground.png');
  }

  .bookList {
    max-height: 20%;
    scroll-behavior: auto;
  }

  .bookSelector {
    justify-content: center;

  }

  .formCard {
    max-width: 80%;
    justify-content: center;
  }

.rtl {
  direction: rtl;
}
  .toggleButtons {
    margin-bottom: 1em;
    margin-top: 1.25em;

  }

  .outerDiv {
    background-color: white;
  }

 .warningtext {
   font-size: 1.25em;
 }


</style>